module.exports = __webpack_public_path__ + "static/media/3-iveco-mercedes.b40e1316.jpg";